import React from 'react';

const TooltipList = ({ text = "", items = [] }) => {
  return (
    <div
      className="tooltip-wrapper"
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
        {`${text} (${items.length})`}
      </span>

      <div
        className="tooltip-box"
        style={{
          position: 'absolute',
          bottom: '100%',       // Tooltip above
          left: 0,
          marginBottom: '8px',  // Space between text and tooltip
          backgroundColor: '#333',
          color: '#fff',
          padding: '8px',
          borderRadius: '4px',
          zIndex: 1,
          whiteSpace: 'nowrap',
        }}
      >
        <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>

      <style>{`
        .tooltip-wrapper .tooltip-box {
          display: none;
        }
        .tooltip-wrapper:hover .tooltip-box {
          display: block;
        }
      `}</style>
    </div>
  );
};

export default TooltipList;
